class WidgetService {
  rootOrigin = '';

  constructor() {
    const scriptSrc = document
      .querySelector('nlabteam-voice-ai')
      ?.querySelector('script')
      ?.getAttribute('src');

    if (scriptSrc) {
      try {
        const url = new URL(scriptSrc);
        this.rootOrigin = url.origin;

        console.log(this.rootOrigin);
      } catch (error) {
        console.error(error);
      }
    }
  }
}

export const widgetService = new WidgetService();
